/**
 * Reference manifest for a scorecard option card.
 *
 * Epic SP-B (#1387) replaces the rounded-rect scaffold renderer with an
 * option card that shows computed total, rank badge, and per-criterion
 * score cells. Five view modes (table/bubble/quadrant/bar/radar) share
 * this manifest as the underlying data node.
 */

import { createPlanningManifest, type PlanningNodeProps } from '../manifest-base';

export const ScorecardOptionManifest = createPlanningManifest({
  id: 'sc_option',
  domain: 'scorecard',
  label: 'Option',
  accent: '#8b5cf6',
  icon: 'square',
  defaultWidth: 240,
  defaultHeight: 72,
});

export type ScorecardOptionProps = PlanningNodeProps;
